module.exports = __webpack_public_path__ + "img/nfib.f87c9707.jpg";